const state = () => ({
  isDisplayDetail: true,
  selectedDate: new Date(),
  shouldScrollToToday: false,
  shouldScrollToTop: false,
  shouldScrollToSelectedDate: false,

  categories: [],
  selectedCategories: [],
  pinnedCategories: []
})

const getters = {
  categoryIds(state) {
    return state.categories.map(category => category.id)
  }
}

const mutations = {
  setSelectedDate(state, selectedDate) {
    state.selectedDate = selectedDate
  },
  setIsDisplayDetail(state, bool) {
    state.isDisplayDetail = bool
  },
  setSelectedCategories(state, selectedCategories) {
    state.selectedCategories = selectedCategories
  },
  setShouldScrollToToday(state, bool) {
    state.shouldScrollToToday = bool
  },
  setShouldScrollToTop(state, bool) {
    state.shouldScrollToTop = bool
  },
  setShouldScrollToSelectedDate(state, bool) {
    state.shouldScrollToSelectedDate = bool
  },
  setCategories(state, categories) {
    state.categories = categories
  },
  clearCategories(state) {
    state.selectedCategories = []
    state.categories = []
  },
  setPinnedCategories(state, pinnedCategories) {
    state.pinnedCategories = pinnedCategories
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}